import { render, staticRenderFns } from "./BarChartItem.vue?vue&type=template&id=151e1a94"
import script from "./BarChartItem.vue?vue&type=script&lang=js"
export * from "./BarChartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports